
import ConfigFormModal from "../components/ConfigFormModal.vue";
import ExecucaoDetalheModal from "../components/ExecucaoDetalheModal.vue";
import StatusBadge from "../components/StatusBadge.vue";
import envioContabilidadeApi from "../api";
import {
  formatBytes,
  formatDateTime,
  formatPeriodo,
  labelPeriodo,
  labelTipoExecucao,
  normalizeCollection,
} from "@/modules/envio-contabilidade/utils";

export default {
  name: "EnvioContabilidadeIndex",
  components: {
    ConfigFormModal,
    ExecucaoDetalheModal,
    StatusBadge,
  },
  data() {
    return {
      activeTab: 0,
      loading: false,
      loadingExecucoes: false,
      savingConfig: false,
      configuracoes: [],
      execucoes: [],
      itens: [],
      configuracaoSelecionada: null,
      configuracaoHistorico: null,
      execucaoSelecionada: null,
      showConfigModal: false,
      showDetalheModal: false,
    };
  },
  mounted() {
    this.carregarTudo();
  },
  methods: {
    formatBytes,
    formatDateTime,
    formatPeriodo,
    labelPeriodo,
    labelTipoExecucao,
    async carregarTudo() {
      await Promise.all([
        this.carregarItens(),
        this.carregarConfiguracoes(),
        this.carregarExecucoes(),
      ]);
    },
    async carregarItens() {
      try {
        const payload = await envioContabilidadeApi.listarItens();
        this.itens = normalizeCollection(payload);
      } catch (error) {
        this.notificarErro("Não foi possível carregar os itens para envio.");
      }
    },
    async carregarConfiguracoes() {
      this.loading = true;

      try {
        const payload = await envioContabilidadeApi.listarConfiguracoes();
        this.configuracoes = normalizeCollection(payload);
      } catch (error) {
        this.notificarErro("Não foi possível carregar as configurações.");
      } finally {
        this.loading = false;
      }
    },
    async carregarExecucoes() {
      this.loadingExecucoes = true;

      try {
        const params = {};

        if (this.configuracaoHistorico) {
          params.config_id = this.configuracaoHistorico.id;
        }

        const payload = await envioContabilidadeApi.listarExecucoes(params);
        this.execucoes = normalizeCollection(payload);
      } catch (error) {
        this.notificarErro("Não foi possível carregar o Histórico.");
      } finally {
        this.loadingExecucoes = false;
      }
    },
    novaConfiguracao() {
      this.configuracaoSelecionada = null;
      this.showConfigModal = true;
    },
    editarConfiguracao(configuracao) {
      this.configuracaoSelecionada = { ...configuracao };
      this.showConfigModal = true;
    },
    fecharConfigModal() {
      this.showConfigModal = false;
      this.configuracaoSelecionada = null;
    },
    async salvarConfiguracao(payload) {
      this.savingConfig = true;

      try {
        if (this.configuracaoSelecionada && this.configuracaoSelecionada.id) {
          await envioContabilidadeApi.editarConfiguracao(
            this.configuracaoSelecionada.id,
            payload
          );
          this.notificarSucesso("Configuração salva com sucesso.");
        } else {
          await envioContabilidadeApi.criarConfiguracao(payload);
          this.notificarSucesso("Configuração salva com sucesso.");
        }

        this.fecharConfigModal();
        await this.carregarConfiguracoes();
      } catch (error) {
        this.notificarErro("Não foi possível salvar a configuração.");
      } finally {
        this.savingConfig = false;
      }
    },
    async executarAgora(configuracao) {
      if (!window.confirm("Deseja enviar esta configuração para a fila agora? Use apenas para testes locais.")) {
        return;
      }

      try {
        await envioContabilidadeApi.executarAgora(configuracao.id);
        this.notificarSucesso("Configuração enviada para a fila agora.");
        await this.carregarExecucoes();
      } catch (error) {
        this.notificarErro("Não foi possível enviar para a fila agora.");
      }
    },
    async enviarTeste(configuracao) {
      if (!window.confirm("Deseja enviar um teste desta configuração?")) {
        return;
      }

      try {
        await envioContabilidadeApi.enviarTeste(configuracao.id);
        this.notificarSucesso("Envio de teste enviado para a fila.");
        await this.carregarExecucoes();
      } catch (error) {
        this.notificarErro("Não foi possível enviar o teste.");
      }
    },
    async alterarStatusConfiguracao(configuracao) {
      const proximoStatus = !configuracao.ativo;
      const acao = proximoStatus ? "ativar" : "desativar";

      if (!window.confirm(`Deseja ${acao} esta configuração?`)) {
        return;
      }

      try {
        await envioContabilidadeApi.alterarStatusConfiguracao(
          configuracao,
          proximoStatus
        );
        this.notificarSucesso(
          `Configuração ${
            proximoStatus ? "ativada" : "desativada"
          } com sucesso.`
        );
        await this.carregarConfiguracoes();
      } catch (error) {
        this.notificarErro(`Não foi possível ${acao} a configuração.`);
      }
    },
    async excluirConfiguracao(configuracao) {
      if (!window.confirm("Deseja excluir esta configuração?")) {
        return;
      }

      try {
        await envioContabilidadeApi.excluirConfiguracao(configuracao.id);
        this.notificarSucesso("Configuração removida com sucesso.");
        await this.carregarConfiguracoes();
      } catch (error) {
        this.notificarErro("Não foi possível excluir a configuração.");
      }
    },
    async verHistorico(configuracao) {
      this.configuracaoHistorico = configuracao;
      this.activeTab = 1;
      await this.carregarExecucoes();
    },
    async limparFiltroHistorico() {
      this.configuracaoHistorico = null;
      await this.carregarExecucoes();
    },
    async detalharExecucao(execucao) {
      try {
        const payload = await envioContabilidadeApi.detalharExecucao(execucao.id);
        this.execucaoSelecionada = payload.data || payload;
        this.showDetalheModal = true;
      } catch (error) {
        this.notificarErro("Não foi possível carregar o detalhe da execução.");
      }
    },
    fecharDetalheModal() {
      this.showDetalheModal = false;
      this.execucaoSelecionada = null;
    },
    async baixarPacote(execucao) {
      try {
        const payload = await envioContabilidadeApi.baixarPacote(execucao.id);
        const url = payload.url || (payload.data && payload.data.url);

        if (!url) {
          this.notificarErro("Não foi possível baixar o Pacote ZIP.");
          return;
        }

        window.open(url, "_blank");
      } catch (error) {
        this.notificarErro("Não foi possível baixar o Pacote ZIP.");
      }
    },
    async reenviar(execucao) {
      if (!window.confirm("Deseja reenviar o e-mail desta execução?")) {
        return;
      }

      try {
        await envioContabilidadeApi.reenviar(execucao.id);
        this.notificarSucesso("Reenvio enviado para a fila.");
        await this.carregarExecucoes();
      } catch (error) {
        this.notificarErro("Não foi possível reenviar o e-mail.");
      }
    },
    temPacote(execucao) {
      return Boolean(execucao && (execucao.zip_url || execucao.zip_path));
    },
    listaEmails(emails) {
      return Array.isArray(emails) && emails.length > 0 ? emails.join(", ") : "-";
    },
    notificarSucesso(message) {
      if (this.$toast) {
        this.$toast.success(message);
      }
    },
    notificarErro(message) {
      if (this.$toast) {
        this.$toast.error(message);
      }
    },
  },
};
